import { RobotoPrincipalUnderlineLink } from "@/shared/components/principal";
import { FormattedDateTime } from "@/shared/datetime";
import {
  COMPLETED_BY_ROBOTO,
  type SessionRecord,
} from "@/shared/domain/sessions";

import { inactivityPhrase } from "./inactivityPhrase";
import styles from "./SessionCompletion.module.css";

/** How the session will be marked complete, or when and by whom it was. */
export function CompletionDescription({ session }: { session: SessionRecord }) {
  if (session.status === "complete") {
    return <CompletedDescription session={session} />;
  }
  if (session.completion_policy === null) {
    return <>When someone marks it complete</>;
  }
  const inactivity = inactivityPhrase(
    session.completion_policy.inactivity_minutes,
  );
  if (session.completes_at === null) {
    return <>Completes automatically {inactivity} after a file is last added</>;
  }
  return (
    <>
      Completes automatically at{" "}
      <FormattedDateTime value={session.completes_at} timeZone /> unless another
      file is added ({inactivity} without a new file)
    </>
  );
}

function CompletedDescription({ session }: { session: SessionRecord }) {
  if (session.completed_at === null) {
    return <>Completed</>;
  }
  if (
    session.completed_by === COMPLETED_BY_ROBOTO ||
    session.completed_by === null
  ) {
    const policy = session.completion_policy;
    return (
      <>
        Completed <FormattedDateTime value={session.completed_at} timeZone />
        {session.completed_by === COMPLETED_BY_ROBOTO && " automatically"}
        {session.completed_by === COMPLETED_BY_ROBOTO &&
          policy !== null &&
          ` after ${inactivityPhrase(policy.inactivity_minutes)} without a new file`}
      </>
    );
  }
  return (
    <>
      Completed <FormattedDateTime value={session.completed_at} timeZone />
      {" by "}
      <RobotoPrincipalUnderlineLink
        className={styles.inlinePrincipal}
        principal={session.completed_by}
      />
    </>
  );
}
